import { render, staticRenderFns } from "./ProjectNavControls.vue?vue&type=template&id=37716995&scoped=true&"
import script from "./ProjectNavControls.vue?vue&type=script&lang=js&"
export * from "./ProjectNavControls.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNavControls.vue?vue&type=style&index=0&id=37716995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37716995",
  null
  
)

export default component.exports